import React from 'react';
import InfoIcon from '@ingka/ssr-icon/paths/information-circle';
import styled from 'styled-components';
import Button, { ButtonTypeEnum } from 'ui/Button/Button';
import { useIntl } from 'react-intl';

const StyledButton = styled(Button)`
  z-index: 1;
  background-color: white;
`;

const InfoButton = ({
  onClick,
  dataTestId,
  disabled,
  id,
  productTitle
}: {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  dataTestId: string;
  overflowContainer?: boolean;
  disabled?: boolean;
  id?: string | string[];
  productTitle: string;
}) => {
  const { formatMessage } = useIntl();
  const accessibleButtonName =
    formatMessage({ id: 'storageone.ariaOpenProductInfo' }) + ' ' + productTitle;
  const formattedAccessibleButtonName =
    accessibleButtonName.charAt(0).toUpperCase() + accessibleButtonName.slice(1).toLowerCase();

  return (
    <StyledButton
      disabled={disabled}
      ssrIcon={InfoIcon}
      text={formattedAccessibleButtonName}
      dataTestId={dataTestId}
      onClick={onClick}
      style={{
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'cursor',
        pointerEvents: disabled ? 'none' : 'auto'
      }}
      size="xsmall"
      iconOnly
      type={ButtonTypeEnum.tertiary}
      buttonId={'info-btn' + id}
    />
  );
};

export default InfoButton;
